<template>
  <div>
    <PatientProfileModalSkeleton v-if="!patientData.isLoaded" />
    <div
      v-else
      class="text--text pa-4"
    >
      <div class="text-subtitle-1 mb-6">
        {{ tStatic('Доверие к профилю') }}
      </div>
      <PatientProfileTrustInfo
        class="mb-6"
        :trust-percent="patientData.trust_percent || 0"
        :can-trust="Boolean(patientData.can_trust)"
      />
      <PatientProfileCriteria
        class="mb-10"
        :criteria="patientData.trust_criteria || []"
      />
      <PatinetProfileRatesStatistic
        class="mb-10"
        :count-canceled="patientData.count_rates_canceled || 0"
        :count-negative="patientData.count_rates_negative || 0"
        :count-positive="patientData.count_rates_positive || 0"
        :count-without-mark="patientData.count_rates_without_mark || 0"
      />
      <div class="d-flex justify-space-between text-subtitle-1">
        <span class="mr-4">
          {{ tStatic('Записи на приём через') }} <br> {{ brandName }}
        </span>
        <span data-qa="patient_profile_count_appointments">
          {{ patientData.count_appointments || tStatic('Нет') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import PatientProfileCriteria from 'www/vue_components/common/PatientProfile/components/common/PatientProfileCriteria.vue'
import PatientProfileModalSkeleton from 'www/vue_components/common/PatientProfile/components/common/PatientProfileModalSkeleton.vue'
import PatientProfileTrustInfo from 'www/vue_components/common/PatientProfile/components/common/PatientProfileTrustInfo.vue'
import PatinetProfileRatesStatistic from 'www/vue_components/common/PatientProfile/components/common/PatinetProfileRatesStatistic.vue'
import type { PatientProfileData } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/PatientProfile/types'

defineProps<{
  patientData: PatientProfileData
}>()

const brandName = computed(() => (
  typeof window !== 'undefined' && window.IS_YDOC ? 'YDoc' : tStatic('Продокторов')
))
</script>
